import type { OptgroupHTMLAttributes, OptionHTMLAttributes, SelectHTMLAttributes } from 'react';
import classnames from 'classnames';
import formStyles from '../../styles/form-control.module.scss';
import styles from './Dropdown.module.scss';

type DropdownProps = Omit<SelectHTMLAttributes<HTMLSelectElement>, 'size'>;
type DropdownItemProps = OptionHTMLAttributes<HTMLOptionElement>;
type DropdownGroupProps = OptgroupHTMLAttributes<HTMLOptGroupElement>;

export function Dropdown({ className, children, ...props }: DropdownProps): JSX.Element {
  return (
    <select className={classnames(formStyles.formControl, styles.select, className)} {...props}>
      {children}
    </select>
  );
}

export function DropdownItem({ className, children, ...props }: DropdownItemProps): JSX.Element {
  return (
    <option className={classnames(styles.option, className)} {...props}>
      {children}
    </option>
  );
}

/** A labeled group of `DropdownItem`s inside a `Dropdown`. */
export function DropdownGroup({ className, children, ...props }: DropdownGroupProps): JSX.Element {
  return (
    <optgroup className={classnames(styles.group, className)} {...props}>
      {children}
    </optgroup>
  );
}
